export default "__VITE_PUBLIC_ASSET__613b5434__"